import { mediaUrl } from "@/lib/api";

export function parseEmbed(url) {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/i);
  if (yt) return { provider: "youtube", id: yt[1], embed: `https://www.youtube-nocookie.com/embed/${yt[1]}?rel=0&modestbranding=1&playsinline=1`, thumb: `https://i.ytimg.com/vi/${yt[1]}/hqdefault.jpg` };
  const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/i);
  if (vm) return { provider: "vimeo", id: vm[1], embed: `https://player.vimeo.com/video/${vm[1]}?dnt=1`, thumb: `https://vumbnail.com/${vm[1]}.jpg` };
  return null;
}

export function mediaKind(url, type) {
  if (type === "embed" || parseEmbed(url)) return "embed";
  if (type === "video" || /\.(mp4|mov|webm|m4v)(\?|$)/i.test(url || "")) return "video";
  return "image";
}

// Normalised list of {url, kind, poster} for an item (service or portfolio).
export function mediaList(item) {
  if (!item) return [];
  const imgs = item.images && item.images.length ? item.images : [item.image].filter(Boolean);
  return imgs.map((url, i) => ({ url, kind: mediaKind(url, (item.media_types || [])[i]), poster: (item.posters || [])[i] || "" }));
}

export function coverOf(item) {
  const list = mediaList(item);
  const m = list.find((x) => x.url === item?.image) || list[0];
  if (!m) return { src: "", kind: "image" };
  if (m.kind === "embed") return { src: parseEmbed(m.url).thumb, kind: "embed" };
  if (m.kind === "video") return { src: m.poster ? mediaUrl(m.poster) : "", video: mediaUrl(m.url), kind: "video" };
  return { src: mediaUrl(m.url), kind: "image" };
}

export function coverIndex(item) {
  const i = mediaList(item).findIndex((x) => x.url === item?.image);
  return i < 0 ? 0 : i;
}
